import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { endOfDay, format } from 'date-fns'
import { toast } from 'react-toastify'
import { FiFile } from 'react-icons/fi'

import { api, authHeaders } from '~/services/api'

import { Button, Calendar, Select, Textbox } from '~/components/Form'
import Spinner from '~/components/Spinner'

import { Container, ButtonContainer } from './styles'
import rangeDayGif from '~/assets/images/gifs/periodo-dias.gif'

import Yup from '~/services/yup'
import { forceDownloadFileFromURL } from '~/util/file'

const initialValues = {
    periodo: '',
    crm: '',
    nome: ''
}

const validation = Yup.object().shape({
    periodo: Yup.string().required('Informe o período.'),
    crm: Yup.string(),
    nome: Yup.string().nullable()
})

export default function () {
    const [diretores, setDiretores] = useState(null)

    async function loadDiretores() {
        try {
            const response = await api.get('diretoria', authHeaders())

            setDiretores(response.map(diretor => ({
                value: diretor.pessoa.documentos[0].identificador,
                label: diretor.pessoa.nome
            })))
        } catch (e) {
            toast.error(e.msg)
        }
    }

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        try {
            let {
                periodo,
                crm,
                nome
            } = values

            const [inicio, fim] = periodo

            if (!crm && !nome) {
                toast.info('Informe o crm ou selecione um diretor!')
                return
            }

            const response = await api.post('relatorio/usuario_atividades/analitico', {
                inicio: format(inicio, 'yyyy-MM-dd HH:mm:ss'),
                fim: format(endOfDay(fim), 'yyyy-MM-dd HH:mm:ss'),
                crm: crm || nome.value
            }, authHeaders())

            forceDownloadFileFromURL(response.link, 'Relatório')

            resetForm()
        } catch (e) {
            toast.error(e.msg)
        }
    }, [])

    useEffect(() => {
        loadDiretores()
    }, [])

    return (
        <Container className="animated fadeIn faster" style={{ gridArea: 'form' }}>
            <h1>Relatório Analítico de Atividades no Sistema</h1>

            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
                containerStyle={{ gridArea: 'form' }}
            >
                {({
                    isSubmitting, setFieldValue, resetForm
                }) => (
                    <Form>
                        <Textbox
                            label="CRM"
                            name="crm"
                            onFocus={() => {
                                setFieldValue('nome', '')
                            }}
                            containerStyle={{ gridArea: 'f1' }}
                        />

                        <Select
                            name="nome"
                            label="Nome"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={diretores}
                            onFocus={() => {
                                setFieldValue('crm', '')
                            }}
                            containerStyle={{ gridArea: 'f2' }}
                        />

                        <Calendar
                            name="periodo"
                            label="Período para busca"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f3' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                            containerStyle={{ gridArea: 'spinner' }}
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="transparent"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
